import styled from 'styled-components';

export const LimitWidthStyle = styled.div`
  width: 95%;
  max-width: 1170px;
  margin: auto;
  ${({ theme, widthOnMobile }) => theme.media.phone`
    width : ${widthOnMobile || '95%'}
  `}

  ${({ extendStyle }) => extendStyle || ''}
`;
